var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C38.8065 0 50 11.1935 50 25C50 38.8065 38.806 50 25 50C11.194 50 0 38.8095 0 25C0 11.1905 11.192 0 25 0Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0854 21.6691V17.9501H36.5899V12.2836H13.4319V17.9501H21.9374V21.6661C15.0249 21.9836 9.82739 23.3526 9.82739 24.9926C9.82739 26.6326 15.0274 28.0016 21.9374 28.3211V40.2336H28.0874V28.3201C34.9874 28.0016 40.1744 26.6336 40.1744 24.9951C40.1744 23.3566 34.9874 21.9886 28.0874 21.6701M28.0874 27.3111V27.3081C27.9139 27.3191 27.0224 27.3726 25.0374 27.3726C23.4504 27.3726 22.3339 27.3276 21.9404 27.3071V27.3121C15.8334 27.0416 11.2749 25.9781 11.2749 24.7056C11.2749 23.4331 15.8339 22.3711 21.9404 22.1001V26.2526C22.3404 26.2801 23.4844 26.3476 25.0634 26.3476C26.9599 26.3476 27.9134 26.2686 28.0884 26.2526V22.1001C34.1834 22.3716 38.7314 23.4361 38.7314 24.7041C38.7314 25.9721 34.1814 27.0371 28.0884 27.3086",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.224e515a88b6ca04039949f3343b9e05.svg";
export { ForwardRef as ReactComponent };